module.exports = __webpack_public_path__ + "img/avatar.764f13d4.png";